<script setup lang="ts">
import { Color } from '@afinius/types/Color';
import { classNames } from '@afinius/utilities/class-names';

interface Props {
  backgroundColor?: Color;
  width?: 'md' | 'lg';
  hasOffset?: boolean;
}

withDefaults(defineProps<Props>(), {
  backgroundColor: undefined,
  width: undefined,
});
</script>

<template>
  <div class="container" :style="{ backgroundColor }">
    <div class="container-content" :class="classNames({ width, hasOffset })">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use './Container.scss';
</style>
